import React from 'react';
import Editable from '../common/editable';
import InspectorCard from './inspector_card';

const cohortSummary = props => {
  return (
    <div className="abl-label-group">
      <label>Cohorts</label>
      <div className="abl-label-content">
        <ul className="abl-participant-list">
          {props.meetingDetails.cohorts.map((cohort, i) => {
            return (
              <li key={i}>{cohort.id}</li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default function MeetingSummary(props) {
  
	return (
    <InspectorCard header="Summary" {...props}>
      <div className="abl-inspector-group abl-meeting-details">
        <div className="abl-label-group">
          <label>Name</label>
          <div className="abl-label-content abl-editable abl-form-field">
            <Editable 
              onChange={props.onChange}
              tagName="span"
              className="abl-editable-label"
              defaultText="Untitled"
              data={props.meetings}
              value={props.meetingDetails.name} />
          </div>
        </div>
        <div className="abl-label-group">
          <label>Staff</label>
          <div className="abl-label-content">
            <ul className="abl-participant-list">
              {props.meetingDetails.teachers.map((teacher, i) => {
                return (
                  <li key={i}>{teacher.name}</li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="abl-inspector-group-2-col">
          <div className="abl-label-group">
            <label>Start</label>
            <div className="abl-label-content abl-form-field">
              {props.meetingDetails.start_time}
            </div>
          </div>
          <div className="abl-label-group">
            <label>Stop</label>
            <div className="abl-label-content abl-form-field">
              {props.meetingDetails.end_time}
            </div>
          </div>
        </div>
        <div className="abl-label-group">
          <label>Duration</label>
          <div className="abl-label-content">
            {props.meetingDetails.durationString}
          </div>
        </div>
        {cohortSummary(props)}
      </div>
    </InspectorCard>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule_inspector/meeting_summary.js
 **/